import { GoogleGenerativeAI } from "https://cdn.jsdelivr.net/npm/@google/generative-ai/+esm";

class GenerativeArtCreator extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.apiKey = 'AIzaSyBlAy3KjBHr5BEjcNQkOyPxPtlrT41YSo8';
    
    this.locations = [{ name: 'Chest' }, { name: 'Back' }, { name: 'Sleeve' }];
    this.currentStep = 0;
    this.currentStatus = 'initial'; // initial, editing, finalizing, awaiting_next_step, complete
    this.generatedDesigns = {};
    this.activeImageUrl = null;
    this.aspectRatio = 1;
    this.variantId = this.getAttribute('variant-id') || '45612478988526'; // Default or from attribute

    this.shadowRoot.innerHTML = `
      <style>
        :host {
            display: flex; flex-direction: column; gap: 1rem; padding: 2rem;
            background-color: #fff; border-radius: 1rem; box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            max-width: 550px; margin: 0 auto; box-sizing: border-box;
        }
        .hidden { display: none !important; }
        #main-image-container { 
            width: 100%; aspect-ratio: 1 / 1; background-color: #f9f9f9; border: 1px solid #e5e5e5;
            border-radius: 0.5rem; display: grid; place-content: center; overflow: hidden; position: relative;
        }
        #main-image-container img { width: 100%; height: 100%; object-fit: cover; }
        .location-title {
            position: absolute; top: 1rem; left: 1rem; background: rgba(0,0,0,0.7); color: white;
            padding: 0.5rem 1rem; border-radius: 0.25rem; font-weight: bold; font-size: 1.2rem;
        }
        #thumbnail-gallery { display: flex; justify-content: flex-end; gap: 2px; min-height: 60px; }
        .thumbnail { width: 60px; height: 60px; border-radius: 4px; object-fit: cover; cursor: pointer; }
        #step-label { text-align: center; font-size: 1.2rem; font-weight: bold; margin-bottom: 0.5rem; }
        textarea.prompt-input { 
            width: 100%; box-sizing: border-box; height: 80px; padding: 1rem; 
            border: 1px solid #d9d9d9; border-radius: 0.5rem; font-size: 1rem; resize: vertical;
        }
        .button-group { display: flex; gap: 1rem; justify-content: center; width: 100%; margin-top: 0.5rem; }
        .dimensions-group { display: flex; gap: 1rem; justify-content: center; width: 100%; margin-top: 1rem; }
        .dimension-input { display: flex; flex-direction: column; gap: 0.25rem; }
        .dimension-input label { font-size: 0.9rem; color: #555; }
        .dimension-input input { width: 100px; padding: 0.5rem; border: 1px solid #d9d9d9; border-radius: 0.25rem; }

        button { 
            padding: 1rem 1.5rem; border: none; border-radius: 0.5rem; font-size: 1rem;
            cursor: pointer; transition: background-color 0.3s ease; flex-grow: 1;
        }
        button:disabled { background-color: #ccc; cursor: not-allowed; }
        #generate-btn, #edit-btn, #next-yes-btn, #finalize-btn { background-color: #007bff; color: #fff; }
        #upload-btn-label { background-color: #6c757d; color: #fff; padding: 1rem 1.5rem; border-radius: 0.5rem; text-align: center; cursor: pointer; flex-grow: 1; }
        #confirm-btn { background-color: #28a745; color: #fff; }
        #reset-btn, #next-no-btn, #back-to-edit-btn { background-color: #dc3545; color: #fff; }
        #add-to-cart-btn { background-color: #ffc107; color: #000; font-size: 1.2rem; font-weight: bold; }
        #total-price { text-align: right; font-size: 1.5rem; font-weight: bold; margin-top: 1rem; }
      </style>

      <div id="main-image-container">
        <span id="main-image-placeholder">Your design will appear here.</span>
        <img id="main-image" class="hidden"/>
        <div id="location-title" class="location-title hidden"></div>
      </div>
      <div id="thumbnail-gallery"></div>
      <div id="step-label"></div>

      <!-- Step: Initial Action -->
      <div id="step-initial">
        <textarea id="prompt-initial" class="prompt-input" placeholder="Describe a new design..."></textarea>
        <div class="button-group">
          <button id="generate-btn">Generate</button>
          <input type="file" id="upload-input" class="hidden" accept="image/*" capture>
          <label for="upload-input" id="upload-btn-label">Upload Image</label>
        </div>
      </div>

      <!-- Step: Editing -->
      <div id="step-editing" class="hidden">
        <textarea id="prompt-edit" class="prompt-input" placeholder="Optional: Describe edits to apply..."></textarea>
        <div class="button-group">
            <button id="edit-btn">Apply Edits</button>
            <button id="finalize-btn">Finalize Design</button>
        </div>
        <div class="button-group">
             <button id="reset-btn">Start Over</button>
        </div>
      </div>

      <!-- Step: Finalizing -->
      <div id="step-finalizing" class="hidden">
          <div class="dimensions-group">
              <div class="dimension-input">
                  <label for="width">Width</label>
                  <input type="number" id="width" placeholder="inches">
              </div>
              <div class="dimension-input">
                  <label for="height">Height</label>
                  <input type="number" id="height" placeholder="inches">
              </div>
          </div>
          <textarea id="instructions" class="prompt-input" placeholder="Optional: Additional instructions for the printer..."></textarea>
          <div class="button-group">
              <button id="confirm-btn">Confirm & Lock Design</button>
          </div>
           <div class="button-group">
              <button id="back-to-edit-btn">Back to Editing</button>
          </div>
      </div>
      
      <!-- Step: Next Location Prompt -->
      <div id="step-next-prompt" class="hidden">
          <div class="button-group">
              <button id="next-yes-btn">Next Location</button>
              <button id="next-no-btn">No thanks, I'm done</button>
          </div>
      </div>

      <!-- Step: Complete -->
      <div id="step-complete" class="hidden">
          <textarea id="overall-instructions" class="prompt-input" placeholder="Optional: Any overall instructions for your order..."></textarea>
          <div class="button-group">
            <button id="add-to-cart-btn">Add to Cart</button>
          </div>
      </div>

      <div id="total-price">$0.00</div>
    `;

    this.ui = {
        mainImage: this.shadowRoot.querySelector('#main-image'),
        mainImagePlaceholder: this.shadowRoot.querySelector('#main-image-placeholder'),
        locationTitle: this.shadowRoot.querySelector('#location-title'),
        thumbnailGallery: this.shadowRoot.querySelector('#thumbnail-gallery'),
        stepLabel: this.shadowRoot.querySelector('#step-label'),
        totalPriceDisplay: this.shadowRoot.querySelector('#total-price'),
        initialStep: this.shadowRoot.querySelector('#step-initial'),
        editingStep: this.shadowRoot.querySelector('#step-editing'),
        finalizingStep: this.shadowRoot.querySelector('#step-finalizing'),
        nextPromptStep: this.shadowRoot.querySelector('#step-next-prompt'),
        completeStep: this.shadowRoot.querySelector('#step-complete'),
        promptInitialInput: this.shadowRoot.querySelector('#prompt-initial'),
        promptEditInput: this.shadowRoot.querySelector('#prompt-edit'),
        widthInput: this.shadowRoot.querySelector('#width'),
        heightInput: this.shadowRoot.querySelector('#height'),
        instructionsInput: this.shadowRoot.querySelector('#instructions'),
        overallInstructionsInput: this.shadowRoot.querySelector('#overall-instructions'),
        generateBtn: this.shadowRoot.querySelector('#generate-btn'),
        uploadInput: this.shadowRoot.querySelector('#upload-input'),
        editBtn: this.shadowRoot.querySelector('#edit-btn'),
        finalizeBtn: this.shadowRoot.querySelector('#finalize-btn'),
        resetBtn: this.shadowRoot.querySelector('#reset-btn'),
        confirmBtn: this.shadowRoot.querySelector('#confirm-btn'),
        backToEditBtn: this.shadowRoot.querySelector('#back-to-edit-btn'),
        nextYesBtn: this.shadowRoot.querySelector('#next-yes-btn'),
        nextNoBtn: this.shadowRoot.querySelector('#next-no-btn'),
        addToCartBtn: this.shadowRoot.querySelector('#add-to-cart-btn'),
    };
    
    this.addEventListeners();
    this.renderStep();
  }

  addEventListeners() {
      this.ui.generateBtn.addEventListener('click', () => this.performGenerativeAction('text-to-image'));
      this.ui.uploadInput.addEventListener('change', (e) => this.handleFileUpload(e));
      this.ui.editBtn.addEventListener('click', () => this.performGenerativeAction('image-and-text-to-image'));
      this.ui.finalizeBtn.addEventListener('click', () => this.changeStatus('finalizing'));
      this.ui.resetBtn.addEventListener('click', () => this.handleReset());
      this.ui.confirmBtn.addEventListener('click', () => this.handleConfirm());
      this.ui.backToEditBtn.addEventListener('click', () => this.changeStatus('editing'));
      this.ui.nextYesBtn.addEventListener('click', () => this.handleNextStep(true));
      this.ui.nextNoBtn.addEventListener('click', () => this.handleNextStep(false));
      this.ui.widthInput.addEventListener('input', () => this.handleDimensionChange('width'));
      this.ui.heightInput.addEventListener('input', () => this.handleDimensionChange('height'));
      this.ui.addToCartBtn.addEventListener('click', () => this.handleAddToCart());
      this.ui.thumbnailGallery.addEventListener('click', (e) => {
          if (e.target.matches('.thumbnail')) {
              this.ui.mainImage.src = e.target.src;
          }
      });
  }
  
  changeStatus(newStatus) {
    this.currentStatus = newStatus;
    this.renderStep();
  }

  renderStep() {
    const currentLocation = this.locations[this.currentStep];

    // Reset all views
    [this.ui.initialStep, this.ui.editingStep, this.ui.finalizingStep, this.ui.nextPromptStep, this.ui.completeStep, this.ui.locationTitle].forEach(el => el.classList.add('hidden'));

    if (this.currentStatus === 'complete') {
        this.ui.stepLabel.textContent = "Your designs are ready!";
        this.ui.completeStep.classList.remove('hidden');
    } else if (!currentLocation) {
        this.changeStatus('complete');
        return;
    } else {
        this.ui.locationTitle.textContent = currentLocation.name;
        this.ui.locationTitle.classList.remove('hidden');
        this.ui.stepLabel.textContent = `Designing the ${currentLocation.name}`;

        this.ui.initialStep.classList.toggle('hidden', this.currentStatus !== 'initial');
        this.ui.editingStep.classList.toggle('hidden', this.currentStatus !== 'editing');
        this.ui.finalizingStep.classList.toggle('hidden', this.currentStatus !== 'finalizing');
        this.ui.nextPromptStep.classList.toggle('hidden', this.currentStatus !== 'awaiting_next_step');
    }

    this.ui.confirmBtn.disabled = !this.ui.widthInput.value || !this.ui.heightInput.value;

    if (this.activeImageUrl) {
        this.ui.mainImage.src = this.activeImageUrl;
        this.ui.mainImage.classList.remove('hidden');
        this.ui.mainImagePlaceholder.classList.add('hidden');
    } else {
        this.ui.mainImage.src = '';
        this.ui.mainImage.classList.add('hidden');
        this.ui.mainImagePlaceholder.classList.remove('hidden');
        this.ui.mainImagePlaceholder.textContent = 'Upload an image or generate one from text.';
    }
    
    this.updateTotalPrice();
    this.updateThumbnailGallery();
  }

  async performGenerativeAction(action) {
    if (this.apiKey === 'REPLACE_WITH_YOUR_API_KEY') {
        alert('Please configure your Google AI API Key in main.js');
        return;
    }
    this.ui.mainImagePlaceholder.textContent = 'Thinking...';
    this.ui.mainImagePlaceholder.classList.remove('hidden');
    this.ui.mainImage.classList.add('hidden');

    try {
        const genAI = new GoogleGenerativeAI(this.apiKey);
        const model = genAI.getGenerativeModel({
            model: "gemini-2.0-flash-preview-image-generation",
            generationConfig: { responseModalities: ["IMAGE", "TEXT"] },
        });

        let prompt = '';
        let imageParts = [];

        if (action === 'text-to-image') {
            prompt = this.ui.promptInitialInput.value;
            if (!prompt) { alert("Please describe the design."); this.renderStep(); return; }
        } else { // image-and-text-to-image
            prompt = this.ui.promptEditInput.value;
            if (!prompt) { alert("Please describe the edits."); this.renderStep(); return; }
            if (!this.activeImageUrl) { alert("Please upload or generate an image before applying edits."); this.renderStep(); return; }
            const mimeType = this.activeImageUrl.split(';')[0].split(':')[1];
            const base64Data = this.activeImageUrl.split(',')[1];
            imageParts.push({ inlineData: { data: base64Data, mimeType } });
        }

        const result = await model.generateContent([prompt, ...imageParts]);
        const response = result.response;

        const imagePart = response.candidates[0].content.parts.find(p => p.inlineData);

        if (imagePart) {
            this.activeImageUrl = `data:${imagePart.inlineData.mimeType};base64,${imagePart.inlineData.data}`;
            this.changeStatus('editing');
            this.ui.promptEditInput.value = '';
            this.setAspectRatio();
        } else {
            console.error("No image data in response. Full response:", response);
            throw new Error("No image data in response.");
        }
    } catch (error) {
        console.error('Error during generative action:', error);
        this.ui.mainImagePlaceholder.textContent = 'An error occurred. Please try again.';
        this.renderStep();
    }
  }
  
  handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
          this.activeImageUrl = e.target.result;
          this.changeStatus('editing');
          this.setAspectRatio();
      };
      reader.readAsDataURL(file);
  }

  setAspectRatio() {
      const img = new Image();
      img.onload = () => {
          this.aspectRatio = img.width / img.height;
          this.renderStep();
      };
      img.src = this.activeImageUrl;
  }
  
  handleDimensionChange(changedInput) {
      const widthInput = this.ui.widthInput;
      const heightInput = this.ui.heightInput;
      const width = parseFloat(widthInput.value);
      const height = parseFloat(heightInput.value);

      if (changedInput === 'width' && width > 0) {
          heightInput.value = (width / this.aspectRatio).toFixed(2);
      } else if (changedInput === 'height' && height > 0) {
          widthInput.value = (height * this.aspectRatio).toFixed(2);
      }
      this.ui.confirmBtn.disabled = !widthInput.value || !heightInput.value;
  }

  handleConfirm() {
    const width = parseFloat(this.ui.widthInput.value);
    const height = parseFloat(this.ui.heightInput.value);
    const instructions = this.ui.instructionsInput.value;

    if (!width || !height || width <= 0 || height <= 0) {
        alert("Please enter a valid, positive width or height for the print.");
        return;
    }

    const price = (width * height * 0.15) + 5; // $0.15 per square inch + $5 fee

    const currentLocation = this.locations[this.currentStep];
    this.generatedDesigns[currentLocation.name] = {
        imageUrl: this.activeImageUrl,
        price: price,
        width: width,
        height: height,
        instructions: instructions
    };
    this.changeStatus('awaiting_next_step');
  }

  handleReset() {
      this.activeImageUrl = null;
      this.aspectRatio = 1;
      this.changeStatus('initial');
      this.ui.promptInitialInput.value = '';
      this.ui.promptEditInput.value = '';
      this.ui.widthInput.value = '';
      this.ui.heightInput.value = '';
      this.ui.instructionsInput.value = '';
  }
  
  handleNextStep(proceed) {
      if (proceed && this.currentStep < this.locations.length - 1) {
          this.currentStep++;
          this.handleReset();
      } else {
          this.changeStatus('complete');
      }
  }

  async handleAddToCart() {
    this.ui.addToCartBtn.textContent = 'Adding...';
    this.ui.addToCartBtn.disabled = true;

    const properties = {};
    let designCounter = 1;
    for (const location in this.generatedDesigns) {
        const design = this.generatedDesigns[location];
        properties[`_Design ${designCounter} (${location}) Image`] = design.imageUrl;
        properties[`_Design ${designCounter} (${location}) Dimensions`] = `${design.width}" x ${design.height}"`;
        properties[`_Design ${designCounter} (${location}) Price`] = `$${design.price.toFixed(2)}`;
        if (design.instructions) {
            properties[`_Design ${designCounter} (${location}) Instructions`] = design.instructions;
        }
        designCounter++;
    }

    const overallInstructions = this.ui.overallInstructionsInput.value;
    if (overallInstructions) {
        properties['_Overall Instructions'] = overallInstructions;
    }

    const formData = {
        'items': [{
            'id': this.variantId,
            'quantity': 1,
            'properties': properties
        }]
    };

    try {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        window.location = '/cart';
    } catch (error) {
        console.error('Error adding to cart:', error);
        this.ui.addToCartBtn.textContent = 'Add to Cart';
        this.ui.addToCartBtn.disabled = false;
        alert('There was an error adding the item to your cart. Please try again.');
    }
  }

  updateThumbnailGallery() {
      this.ui.thumbnailGallery.innerHTML = '';
      for (const loc in this.generatedDesigns) {
          const thumb = document.createElement('img');
          thumb.src = this.generatedDesigns[loc].imageUrl;
          thumb.dataset.location = loc;
          thumb.classList.add('thumbnail');
          this.ui.thumbnailGallery.appendChild(thumb);
      }
  }

  updateTotalPrice() {
      const total = Object.values(this.generatedDesigns).reduce((sum, design) => sum + design.price, 0);
      this.ui.totalPriceDisplay.textContent = `$${total.toFixed(2)}`;
  }
}

customElements.define('generative-art-creator', GenerativeArtCreator);
